import {
  AssetType,
  TradeControllerVariants,
  TradeOperation,
} from '../../utils/reusableTypes';
import { AppUserFullInfo } from '@bts-web/core-features/common';

const appropriatenessCheckOperations: TradeControllerVariants[] = [
  'buy',
  'savings',
  'swap',
  'order',
];

type AppropriatenessStatus = Pick<
  AppUserFullInfo,
  | 'appropriatenessRequiresTestCompletion'
  | 'appropriatenessRequiresTestResubmission'
  | 'appropriatenessComplexProducts'
>;

interface AppropriatenessCheckParams {
  assetType: string;
  operation?: string;
  assetId?: string;
  searchParams?: Record<string, string>;
  appropriatenessStatus: AppropriatenessStatus;
}

export const getAppropriatenessRedirectUrl = ({
  assetType,
  operation,
  assetId,
  searchParams,
  appropriatenessStatus,
}: AppropriatenessCheckParams): string | null => {
  if (
    !operation ||
    !appropriatenessCheckOperations.includes(
      operation as TradeControllerVariants,
    )
  ) {
    return null;
  }

  const isSecurityAsset = [AssetType.ETC, AssetType.ETF, AssetType.STOCK].some(
    (item) => item === assetType,
  );

  const isEquityComplexAsset = [
    AssetType.EQUITY_COMPLEX_ETC,
    AssetType.EQUITY_COMPLEX_ETF,
  ].some((item) => item === assetType);

  const {
    appropriatenessRequiresTestCompletion,
    appropriatenessRequiresTestResubmission,
    appropriatenessComplexProducts,
  } = appropriatenessStatus;

  const swapSuffix =
    operation === TradeOperation.swap && searchParams?.swapWith
      ? `&swapWith=${encodeURIComponent(searchParams.swapWith)}`
      : '';

  const baseParams = `assetId=${encodeURIComponent(assetId || '')}&next=${encodeURIComponent(operation)}`;

  if (isEquityComplexAsset) {
    const needsComplexProductsTest =
      !appropriatenessComplexProducts ||
      appropriatenessComplexProducts.status === 'UNKNOWN' ||
      appropriatenessComplexProducts.requiresTestResubmission;

    if (!needsComplexProductsTest) {
      return null;
    }

    return `/appropriateness-questions/introduction?flow=complex-products&${baseParams}${swapSuffix}`;
  }

  if (
    !isSecurityAsset ||
    (!appropriatenessRequiresTestCompletion &&
      !appropriatenessRequiresTestResubmission)
  ) {
    return null;
  }

  return `/appropriateness-questions/introduction?${baseParams}${swapSuffix}`;
};
